import { CreateReview } from '../../../components/Admin/Reviews';

const CreateScreen = () => (
    <div className="articles__edit">
        <CreateReview />
    </div>
);

export default CreateScreen;
